import { Injectable } from '@angular/core';
import { File as ApexFile } from 'projects/apex/src/app/models/file';
import { Folder } from 'projects/apex/src/app/models/folder';
import { HttpExtra } from 'projects/apex/src/app/services/http/http-extra';
import { APIService } from 'projects/apex/src/app/services/http/http.service';
import { Observable } from 'rxjs';
import { createApiUrl } from '../../utils/functions';
import { CollectionResponse, EntityResponse } from '../../utils/types';

@Injectable()
export class FolderService extends APIService<Folder> {
  route = 'folder';

  home(extra?: HttpExtra): Observable<EntityResponse<Folder>> {
    return this.get('home', extra);
  }

  upload(extra?: HttpExtra): Observable<EntityResponse<Folder>> {
    return this.get('upload', extra);
  }

  children(id: string, extra?: HttpExtra): Observable<CollectionResponse<Folder>> {
    return this.http.get<CollectionResponse<Folder>>(
      `${this.apiUrl}/${this.route}/${id}/children`,
      this.options(extra),
    );
  }

  files(id: string, extra?: HttpExtra): Observable<CollectionResponse<ApexFile>> {
    return this.http.get<CollectionResponse<ApexFile>>(`${this.apiUrl}/${this.route}/${id}/file`, this.options(extra));
  }

  folder(id: string, extra?: HttpExtra): Observable<EntityResponse<Folder>> {
    return this.http.get<EntityResponse<Folder>>(`${this.apiUrl}/${this.route}/${id}`, this.options(extra));
  }

  update(id: string, folderData: Partial<Folder>, extra?: HttpExtra): Observable<EntityResponse<Folder>> {
    return this.http.post<EntityResponse<Folder>>(createApiUrl(this.route, id), folderData, this.options(extra));
  }

  copy(id: string, destFolder: string, extra?: HttpExtra): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      `${this.apiUrl}/${this.route}/${id}/copy`,
      { destFolder },
      this.options(extra),
    );
  }
}
